/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IBanco from 'Infotrack@Modelos/administracion/banco/entidades/banco';
import React from 'react';
import BancoCM from '../controladorModelo/bancoCM';
import { acciones, IEstadoBanco } from '../reductorBanco';
import BancoVista from '../vista/tablaBancoVista';

const bancoCM = new BancoCM();

const TableBancoCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [bancos, setBancos] = React.useState<IBanco[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoBanco>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarBanco();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarBanco = () => {
        manejadorIndicadorCargaGlobal(true);
        bancoCM.consultarBanco().then((bancos) => {
            setBancos(bancos);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadBanco?: IBanco) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadBanco, tipoFormulario } });
    };

    const confirmarEliminacion = (banco: IBanco) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarBanco(banco),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarBanco = (banco: IBanco) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        bancoCM.eliminarBanco(banco).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <BancoVista
            bancos={bancos}
            cargarBanco={cargarBanco}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableBancoCV;
